import { useState, useEffect } from "react";
import { shouldShowNudge, dismissNudge, loadNudgePreferences, type Nudge } from "../lib/nudges";

export default function NudgeToast() {
  const [nudge, setNudge] = useState<Nudge | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check for nudge on mount and every 5 minutes
    const checkNudge = () => {
      const prefs = loadNudgePreferences();
      const potentialNudge = shouldShowNudge(prefs);
      if (potentialNudge) {
        setNudge(potentialNudge);
        setIsVisible(true);
      }
    };

    // Initial check after a short delay
    const initialTimeout = setTimeout(checkNudge, 3000);

    // Periodic check
    const interval = setInterval(checkNudge, 5 * 60 * 1000);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    if (nudge) {
      dismissNudge(nudge.id);
    }
    setTimeout(() => setNudge(null), 150);
  };

  if (!nudge) return null;

  return (
    <div
      className={`fixed bottom-20 left-4 right-4 md:left-auto md:right-8 md:max-w-sm z-50 transition-all duration-150 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <div className="bg-bg border border-border rounded-md overflow-hidden shadow-sm">
        {/* Header */}
        <div className="px-4 py-2.5 border-b border-border-light flex items-center justify-between">
          <span className="text-sm text-text font-[family-name:--font-ui] font-medium">{nudge.title}</span>
          <button
            onClick={handleDismiss}
            className="text-muted hover:text-text transition-colors"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="px-4 py-3">
          <p className="text-sm text-text mb-2">{nudge.message}</p>

          {nudge.suggestion && (
            <div className="border-t border-border-light pt-2 mt-2">
              <p className="text-sm text-text font-[family-name:--font-ui] font-medium">{nudge.suggestion.food}</p>
              <p className="text-xs text-muted font-[family-name:--font-ui] mt-0.5">{nudge.suggestion.reason}</p>
            </div>
          )}

          <button
            onClick={handleDismiss}
            className="mt-3 text-sm text-muted font-[family-name:--font-ui] hover:text-text transition-colors"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}
